import { QueryParams } from '@utils/queryStringBuilder';

import {
  FormsListSortBy,
  GetActivityLogParams,
  GetDropOffsParams,
  GetFormsParams,
  GetSubmissionsParams
} from '../types';

const FORMS_LIST_SORT_BY_API: Record<FormsListSortBy, string> = {
  name: 'name',
  registrationCount: 'paid_count',
  conversionRate: 'conversion_rate'
};

export const toFormsListQueryParams = (params: GetFormsParams): QueryParams => {
  const query: QueryParams = {};

  if (params.search) {
    query.search = params.search;
  }
  if (params.page !== undefined) {
    query.page = params.page;
  }
  if (params.limit !== undefined) {
    query.limit = params.limit;
  }
  if (params.sortBy) {
    query.sort_by = FORMS_LIST_SORT_BY_API[params.sortBy];
  }
  if (params.sortOrder) {
    query.sort_order = params.sortOrder;
  }
  if (params.status?.length) {
    query.status = params.status.join(',');
  }
  if (params.addTo?.length) {
    query.add_to = params.addTo.join(',');
  }

  return query;
};

export const toSubmissionsQueryParams = (
  params: Pick<GetSubmissionsParams, 'page' | 'limit' | 'search'>
): QueryParams => {
  const query: QueryParams = {};

  if (params.search) {
    query.search = params.search;
  }
  if (params.page !== undefined) {
    query.page = params.page;
  }
  if (params.limit !== undefined) {
    query.limit = params.limit;
  }

  return query;
};

export const toDropOffsQueryParams = (
  params: Pick<GetDropOffsParams, 'page' | 'limit' | 'search' | 'status'>
): QueryParams => {
  const { status, search, page, limit } = params;
  const query: QueryParams = {};

  if (search) {
    query.search = search;
  }
  if (page !== undefined) {
    query.page = page;
  }
  if (limit !== undefined) {
    query.limit = limit;
  }
  if (status && status !== 'all') {
    query.status = status;
  }

  return query;
};

export const toActivityLogQueryParams = (
  params: Pick<GetActivityLogParams, 'page' | 'limit'>
): QueryParams => {
  const query: QueryParams = {};

  if (params.page !== undefined) {
    query.page = params.page;
  }
  if (params.limit !== undefined) {
    query.limit = params.limit;
  }

  return query;
};
